export * from './adjuntos-table/adjuntos-table.component';
